const getExtensionFilename = (filename: string) => {
  return filename.split(".").slice(-1)?.[0];
};

export default getExtensionFilename;
